<template>
  <VueRecaptcha
    ref="recaptcha"
    :sitekey="this.sitekey"
    :loadRecaptchaScript="true"
    size="invisible"
    @verify="validate"
  />
</template>
<script>
import VueRecaptcha from "vue-recaptcha";
export default {
  components: { VueRecaptcha },
  data() {
    return {
      cardInfo: {},
      // sitekey: "6LfPfEIfAAAAAIoOQuCwG1GBpeluj1bknkRRbOhs", //#test key
      sitekey: "6Leg2e8UAAAAAJ2aJOXwTYwKlCaQ5MNg3qVBSa8T",
      empty_key: "-111111",
    };
  },
  methods: {
    resetRecaptcha() {
      this.$refs.recaptcha.reset();
    },
    checkSubmit(data) {
      this.cardInfo = data;
      this.$refs.recaptcha.execute();
      //this.validate();
    },
    validate(response) {
      // response="";
      var isTest = 0;
      this.$insProgress.start();
      this.cardInfo = { ...this.cardInfo, response: response, test: isTest };
      this.$axiosApi
        .post(`card/business/save`, this.cardInfo)
        .then((response) => {
          if (response.data === "Success") {
            this.$emit("checkRecaptcha", response);
            this.$insProgress.finish();
          } else if (response.data.status === 100) {
            this.$emit("recaptchaError", response.message);
            this.$insProgress.finish();
          } else {
            this.$emit("checkRecaptcha", response);
            this.$insProgress.finish();
          }
          this.resetRecaptcha();
        })
        .catch((error) => {
          this.RedirectLogin();
          this.$router.push({ name: "login" });
        });
    },
  },
};
</script>
